import { useToast } from '@components/index'
import { apiClient } from '@services/api-client'
import { BACK_OFFICE_PREFIX } from '@services/utils'
import { useOnError } from '@services/utils/onError'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'

import { scheduledTasksQueryKey } from '../queries/useScheduledTasks'

export function useRunNow() {
  const toast = useToast()
  const queryClient = useQueryClient()
  const onError = useOnError()
  const { t } = useTranslation('cron')

  async function runNow(id: number) {
    await apiClient.post(`${BACK_OFFICE_PREFIX}scheduled-tasks/${id}/run-now`)
  }

  return useMutation({
    mutationFn: runNow,
    onSuccess: () => {
      toast.success({ message: t('toast.runRequested') })
      queryClient.invalidateQueries({ queryKey: scheduledTasksQueryKey })
    },
    onError
  })
}
